import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules';
export default class BusinessModule {
    constructor() {
        this.sections = document.querySelectorAll('.business');
        if (this.sections.length > 0) {
            this.ready();
        }
    }

    ready() {
        this.sections.forEach((section) => {
            const swiperBusinessTab = new Swiper(section.querySelector('.swiper--business-tab'), {
                modules: [Navigation],
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: false,
                navigation: {
                    nextEl: section.querySelector('.swiper-button-next'),
                    prevEl: section.querySelector('.swiper-button-prev'),
                },
            });

            const businessSlidesUpdate = section.querySelectorAll('.swiper--tab-business .swiper-slide');
            businessSlidesUpdate.forEach((slide) => {
                if (slide.dataset.type == 'you') {
                    slide.classList.add('!hidden');
                }
            });

            const swiperBusiness = new Swiper(section.querySelector('.swiper--tab-business'), {
                modules: [Navigation],
                loop: false,
                slidesPerView: 2,
                spaceBetween: 24,
                allowTouchMove: true,
                navigation: {
                    nextEl: section.querySelector('.nav-slider-business .swiper-button-next'),
                    prevEl: section.querySelector('.nav-slider-business .swiper-button-prev'),
                },
            });

            const btnFilters = section.querySelectorAll('.btnFilterBusiness');
            btnFilters.forEach((button) => {
                button.addEventListener('click', () => {
                    btnFilters.forEach((buttonsRemove) => {
                        buttonsRemove.classList.remove('active');
                    });
                    button.classList.add('active');
                    const category = button.dataset.category;
                    businessSlidesUpdate.forEach((slide) => {
                        if (slide.dataset.type == 'business') {
                            if (!slide.classList.contains('cat-' + category)) {
                                slide.classList.add('!hidden');
                            } else {
                                slide.classList.remove('!hidden');
                            }
                        }
                    });
                    swiperBusiness.update();
                });
            });

            //start
            businessSlidesUpdate.forEach((slide) => {
                if (slide.dataset.type == 'business') {
                    if (slide.classList.contains('cat-1')) {
                        slide.classList.remove('!hidden');
                    } else {
                        slide.classList.add('!hidden');
                    }
                }
            });
            swiperBusiness.update();

            const youSlidesUpdate = section.querySelectorAll('.swiper--tab-you .swiper-slide');
            youSlidesUpdate.forEach((slide) => {
                if (slide.dataset.type == 'business') {
                    slide.classList.add('!hidden');
                }
            });

            const youSwiperTab = new Swiper(section.querySelector('.swiper--tab-you'), {
                modules: [Navigation],
                loop: false,
                slidesPerView: 3,
                spaceBetween: 24,
                allowTouchMove: true,
                navigation: {
                    nextEl: section.querySelector('.nav-slider-you .swiper-button-next'),
                    prevEl: section.querySelector('.nav-slider-you .swiper-button-prev'),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    }
}

if (document.querySelector('.business')) {
    try {
        new BusinessModule();
    } catch (e) {}
}
